import ImageZoom from 'js-image-zoom';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../../helpers';

const selectors = {
  mainCarousel: '[data-image-carousel]',
  zoomContainer: '[data-zoom-container]',
  zoom: '[data-zoom]',
  zoomBlocker: '[data-zoom-blocker]',
  zoomPrimaryImage: '[data-zoom-primary-image]',
};

const ZOOM_OPTIONS = {
  zoomPosition: 'original',
  fillContainer: true,
};

/**
 * Product image gallery on the PDP
 *
 * @export
 * @class ProductImages
 */
export default class ProductImages {
  constructor(el) {
    this.el = el;
    this.mainCarousel = this.el.querySelector(selectors.mainCarousel);
    if (this.mainCarousel) {
      this._initCarousel();
    }

    this._initZoomContainers();
  }

  /**
   * Initialize primary image carousel
   */
  _initCarousel() {
    this.mainCarousel = new Splide(this.mainCarousel, {
      perPage: 1,
      pagination: true,
      arrows: false,
      classes: {
        pagination: 'splide__pagination absolute bottom-4 inset-x-0',
      },
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          destroy: true,
        },
      },
    });

    this.mainCarousel.mount();
  }

  _initZoomContainers() {
    const zoomContainers = this.el.querySelectorAll(selectors.zoomContainer);
    zoomContainers.forEach(container => {
      const zoomBlocker = container.querySelector(selectors.zoomBlocker);
      const zoomEl = container.querySelector(selectors.zoom);

      container.addEventListener('mouseenter', () => {
        if (container.getAttribute('data-zoom-container')) {
          return;
        }

        const imageUrl = zoomEl.dataset.zoom;
        const backgroundColor = container.dataset.productBackgroundColor;
        const zoomStyle = backgroundColor
          ? `background-color: ${backgroundColor};`
          : 'background-color: #ffffff;';

        new ImageZoom(zoomEl, {
          ...ZOOM_OPTIONS,
          img: imageUrl,
          zoomStyle,
        });

        container.setAttribute('data-zoom-container', 'true');
      });

      container.addEventListener('mouseleave', () => {
        this._showZoomBlocker(zoomBlocker);
      });

      zoomEl.addEventListener('click', () => {
        this._showZoomBlocker(zoomBlocker);
      });

      zoomBlocker.addEventListener('click', () => {
        this._hideZoomBlocker(zoomBlocker);
      });
    });
  }

  _hideZoomBlocker(el) {
    el.classList.add('hidden');
    const primaryImage = el.closest(selectors.zoomContainer).parentElement?.querySelector(selectors.zoomPrimaryImage);
    if (primaryImage) primaryImage.classList.add('hidden');
  }

  _showZoomBlocker(el) {
    el.classList.remove('hidden');
    const primaryImage = el.closest(selectors.zoomContainer).parentElement?.querySelector(selectors.zoomPrimaryImage);
    if (primaryImage) primaryImage.classList.remove('hidden');
  }
}
